import { useIsAuthenticated } from '@azure/msal-react'
import { Navigate } from 'react-router-dom'

import Login from '../auth/Login/Login'

/**
 * Will redirect to the login page if the user is not authenticated.
 */
export default function AuthRedirect() {
	const isAuthenticated = useIsAuthenticated()

	if (isAuthenticated) {
		return <Navigate to="/app" replace />
	}

	return <Login />
}
